<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">
      <a [routerLink]="['/dash/admin/notes/']" *ngIf="userData.level >= 4">Atención a Clientes</a>
      <a [routerLink]="['/dash/notes/']" *ngIf="userData.level < 3">Atención a Clientes</a> / Detalle</p>
    <h2 class="">Ticket #<span *ngIf="note">{{note.idNote}}</span></h2>
  </div>
</div>

<!-- Info -->
<div class="content-block note-detail">
 
  <div class="dx-card responsive-paddings pt-0">
    <h2>Mensaje</h2>
    <div class="flex flex-nowrap flex-start datagrid-detailsW round-border-2" *ngIf="note">

      <div class="flex-fill mr-5">
        <h2>Datos del Usuario</h2>
        <div class="list-group">
          <div class="list-gorup-item">
            <i class="fad fa-user d-none"></i>Usuario:
            <span class="ml-2">{{ note ? note.userName : null}}</span>
          </div>
          <div class="list-gorup-item">
            <i class="fad fa-email d-none"></i>Email: 
            <span class="ml-2">{{note ? note.email : null}}</span>
          </div>
          <div class="list-gorup-item">
            <i class="fad fa-calendar d-none"></i>Fecha: 
            <span class="ml-2">{{note ? (note.dateCreated | date: 'dd-MM-yyyy hh:mm a') : null }}</span>
          </div>
          <div class="list-gorup-item">
            <i class="fad fa-calendar d-none"></i>Estatus: 
            <span class="ml-2 bold">{{note ? (note.statusName | uppercase ) : null }}</span>
          </div>
          <div class="list-gorup-item">
            <i class="fad fa-comment d-none"></i>Mensaje: 
            <div class="ml-2 brand-color">
              <div><i class="fad fa-quote-left py-2 px-3 brand-color" ></i>{{note ? note.note : null}}</div>
            </div>
          </div>
        </div>

        <!-- New Response -->
        <div>
          <ng-container *ngIf="note && note.status != 6">
            <h2>Nuevo Mensaje</h2>
            <dx-text-area
              placeholder="Escribe un mensaje"
              stylingMode="outlined"
              [height]="90"
              [maxLength]="500"
              [(value)]="noteResponse.note">
            </dx-text-area>
          </ng-container>
          <div *ngIf="note" class="py-2 text-right message-buttons">
            <ng-container *ngIf="(note.status < 5 && note.status > 1) || note.status == 7 ">
              <dx-button text="cerrar ticket" type="default" (onClick)="updateStatus(5)" class='mr-3'></dx-button>
            </ng-container>
            <ng-container *ngIf="note.status < 6 || note.status == 7">
              <dx-button text="Enviar" type="default" (onClick)="addResponse()"></dx-button>
            </ng-container>
            <ng-container *ngIf="note.status == 6">
              <dx-button text="Reabrir Ticket" type="default" (onClick)="updateStatus(7)"></dx-button>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="flex-fill round-border-2 position-relative" >
        <!-- Responses -->
       
        <div id="scrollview-demo">
          <dx-scroll-view #scrollView
              id="scrollview"
              [height]="270"
              [scrollByContent]="true"
              [scrollByThumb]="true"
              showScrollbar="always">
              <div class="note-responses-list" *ngIf="note">
                <ng-container *ngIf="!note.responses || note.responses.length == 0">
                  <div class="align-center">Comentario sin respuestas</div>
                </ng-container>
                <ng-container *ngIf="note.responses && note.responses.length > 0">
                  <!--
                  <div class="note-item">
                    <div class="note">{{note.note}}</div>
                  </div>
                  -->
                  <ng-container *ngFor="let n of note.responses">
                    <div class="note-item">
                      <div class="userName">
                        <ng-container *ngIf="note.idUser != n.idUser">
                          <span *ngIf="userData.id == n.idUser">Yo</span>
                          <span *ngIf="userData.id != n.idUser">{{n.userName}}</span>
                        </ng-container>
                        <ng-container *ngIf="note.idUser == n.idUser">
                          <span>Usuario</span>
                        </ng-container>
                        
                      </div>
                      <div class="note" [ngClass]="{'ihunterNote': note.idUser != n.idUser}">
                        <span [innerHTML]="n.note|linkUrl"></span>
                        <div class="date mr-3">{{n.dateCreated | date: 'dd-MM-yyyy hh:mm a'}}</div>
                      </div>
                      
                    </div>
                  </ng-container>
                  <!--
                  <dx-list [items]="note.responses" height="100%">
                    <div *dxTemplate="let item of 'item'">
                      <div class="product">
                        <div>{{item.note}}</div>
                      </div>
                    </div>
                  </dx-list>
                  -->
                </ng-container>
                <div #endOfResponses></div>
              </div>    
              <div id="end"></div>
          </dx-scroll-view>
        </div>
        
      </div>
    </div>
  </div>
</div>
